export interface StartupConfigValues {
  identityServerApiUrl: string;
  paymentsUiUrl: string;
  instrumentationKey: string;
  mfKey: string;
}

let config: StartupConfigValues = {
  identityServerApiUrl: '',
  paymentsUiUrl: '',
  instrumentationKey: '',
  mfKey: '',
};

const SESSION_STORAGE_STARTUP_CONFIG = 'startupConfig';

const set = (value: StartupConfigValues): void => {
  if (window && window.sessionStorage) {
    window.sessionStorage.setItem(SESSION_STORAGE_STARTUP_CONFIG, JSON.stringify(value));
    config = value;
    return;
  }

  throw Error('sessionStorage is undefined');
};

const get = (): StartupConfigValues => {
  if (window && window.sessionStorage) {
    if (!config.instrumentationKey) {
      const json = window.sessionStorage.getItem(SESSION_STORAGE_STARTUP_CONFIG);
      if (json) {
        config = JSON.parse(json);
      }
    }

    return config;
  }

  throw Error('sessionStorage is undefined');
};

export default {
  set,
  get,
};
